import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter009() {
  return <KbChapterPage slug="chapter-009" />;
}

(Chapter009 as unknown as { path: string }).path = "/theory-album/009";
